module.exports = __webpack_public_path__ + "static/tax-return-475ac1a2653f97c108297f4480059a17.svg";